import Page from '../../page';

export default class BusinessProducts extends Page {
	constructor(...args) {
		super(...args);

		this._retrieveDOM();
		this._initTls();
	}

	_retrieveDOM() {
		super._retrieveDOM();
		
		this.dom.views = {};
	}
	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/business/products/business-products.js